import { ACCOUNT_DETAILS_PAGE_URL, SubMenuList } from "@constants";
import "./css/SubNavigation.scss";
import { Tab, Tabs } from "@mui/material";
import { useHistory } from "react-router-dom";

export const SubNavigation = () => {
    const history = useHistory();

    const getTabsValue = history.location.pathname.includes(ACCOUNT_DETAILS_PAGE_URL)
        ? ACCOUNT_DETAILS_PAGE_URL
        : history.location.pathname;

    return (
        <Tabs
            className="subNavigation"
            classes={{ scroller: "subNavigation__scroll" }}
            scrollButtons="auto"
            textColor="inherit"
            value={getTabsValue}
            variant="scrollable"
        >
            {SubMenuList.map((link) =>
                link.isExternal ? (
                    <Tab
                        className="subNavigation__item"
                        component="a"
                        disableRipple
                        href={link.url}
                        key={link.label}
                        label={link.label}
                    />
                ) : (
                    <Tab
                        className="subNavigation__item"
                        disableRipple
                        key={link.label}
                        label={link.label}
                        value={link.url}
                        onClick={() => history.push(link.url)}
                    />
                )
            )}
        </Tabs>
    );
};
